import { create } from 'zustand'
import { persist } from 'zustand/middleware'

let nextId = Date.now()

export const useNotificationStore = create(
  persist(
    (set, get) => ({
      notifications: [],   // { id, type, title, message, time, read, link }

      add: (notif) => {
        const entry = {
          id:      ++nextId,
          time:    new Date().toISOString(),
          read:    false,
          link:    null,
          ...notif,
        }
        set(s => ({ notifications: [entry, ...s.notifications].slice(0, 30) }))
      },

      markRead: (id) => set(s => ({
        notifications: s.notifications.map(n => n.id === id ? { ...n, read: true } : n)
      })),

      markAllRead: () => set(s => ({
        notifications: s.notifications.map(n => ({ ...n, read: true }))
      })),

      remove: (id) => set(s => ({
        notifications: s.notifications.filter(n => n.id !== id)
      })),

      clearAll: () => set({ notifications: [] }),

      unreadCount: () => get().notifications.filter(n => !n.read).length,
    }),
    { name: 'tonys-notifications' }
  )
)
